import { teApi, omsApi } from 'yxt-biz-pc/packages/api';

// 获取全部列表
export const getList = (url, query) => {
  return teApi.get(url, { params: query });
};

// 获取讲师分类列表
export const getCatalogList = () => {
  return teApi.get('/te/catalog/list/select');
};

// 获取选择的类型
export const getChooseType = () => {
  return teApi.get('/externalfacade/o2o/choose/type');
};

export const getTopicList = data => {
  return omsApi.post('/specialtopic/select', data);
};
